import { createFetch, type CreateFetchOption } from "@better-fetch/fetch";

import SuperJSON from "superjson";

function createCustomFetch(options: CreateFetchOption = { throw: false }) {
  return createFetch({
    baseURL: process.env.BUN_PUBLIC_API_URL,
    ...options,
  });
}

const $fetch = createFetch({
  baseURL: process.env.BUN_PUBLIC_API_URL,
  auth: {
    type: "Bearer",
    token: () => localStorage.getItem("auth-token") ?? "",
  },
  jsonParser: (text): unknown => {
    if (!text) return;
    if (text.startsWith('{"json"')) {
      return SuperJSON.parse(text);
    }

    return JSON.parse(text);
  },
  throw: true,
});

export { $fetch, createCustomFetch };
